import { useState, type FormEvent } from "react";

interface CommentItem {
  id: number;
  name: string;
  time: string;
  content: string;
}

const initialComments: CommentItem[] = [
  {
    id: 1,
    name: "夏目的小狐狸",
    time: "2 小时前",
    content: "看到中段才明白，这个故事讲的其实不是冒险，而是怎么好好告别。",
  },
  {
    id: 2,
    name: "夜航星",
    time: "昨天 21:40",
    content: "配乐太克制了，每次都在快要哭出来的时候把声音收回去，反而更难受。",
  },
  {
    id: 3,
    name: "花火",
    time: "3 天前",
    content: "已经二刷，第二遍会注意到很多第一遍忽略的细节，推荐慢慢看。",
  },
];

export default function CommentSection() {
  const [comments, setComments] = useState<CommentItem[]>(initialComments);
  const [draft, setDraft] = useState("");
  const [notice, setNotice] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = draft.trim();
    if (!value) {
      setNotice("先写点什么再发表吧。");
      return;
    }
    if (value.length > 200) {
      setNotice("评论请控制在 200 字以内。");
      return;
    }
    setComments((prev) => [
      {
        id: Date.now(),
        name: "本机访客",
        time: "刚刚",
        content: value,
      },
      ...prev,
    ]);
    setDraft("");
    setNotice("评论已添加到本页（演示，不会上传服务器）。");
  };

  return (
    <section>
      <div className="flex items-end justify-between">
        <div>
          <h2 className="text-lg font-bold text-foreground-950">评论区</h2>
          <p className="mt-1 text-xs text-foreground-500">演示状态，评论仅保存在当前页面，刷新后会恢复初始示例。</p>
        </div>
        <span className="font-label text-xs text-foreground-500">{comments.length} 条</span>
      </div>

      <form onSubmit={handleSubmit} className="mt-4">
        <textarea
          value={draft}
          onChange={(event) => {
            setDraft(event.target.value);
            setNotice("");
          }}
          maxLength={200}
          rows={3}
          placeholder="说说你对这部作品的看法……"
          className="w-full resize-none rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
        />
        <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p className={notice.includes("演示") ? "text-xs text-primary-600" : "text-xs text-foreground-500"}>
            {notice || `${draft.length} / 200 字`}
          </p>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            发表评论
          </button>
        </div>
      </form>

      <ul className="mt-5 divide-y divide-background-200">
        {comments.map((comment) => (
          <li key={comment.id} className="flex gap-3 py-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 font-label text-xs text-secondary-900">
              {comment.name.slice(0, 1)}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-medium text-foreground-900">{comment.name}</span>
                <span className="text-[11px] text-foreground-400">{comment.time}</span>
              </div>
              <p className="mt-1 text-sm leading-relaxed text-foreground-700">{comment.content}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}